var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from 'classnames';
import useDimensions from 'react-cool-dimensions';
import { hasValue } from '../../../utils';
import SampleDataLabel from './SampleDataLabel';
/**
 *
 * @export
 *
 * This is a standard wrapper for widgets.
 * It provides basic visual styling for common widgets. You should generally wrap all your widgets in this.
 *
 * @example
 * ```
 * <WidgetWrapper>
 *  <Label>My custom widget</Label>
 * </WidgetWrapper>
 * ```
 *
 * @example
 *
 * ```
 * You can define custom break points for the widget and use css to make the widget responsive
 * Uxp will automatically apply the relevant class based on the width or height of the widget wrapper.
 * these class names will be prefixed with either `w-` (for width) or `h-` (for height)
 * then you can write css to make the widgets resposive
 * <WidgetWrapper
 *      cssBreakPoints={{
 *          width: {
 *              default: 'larger',
 *              100: 'smaller',
 *              200: 'small',
 *              300: 'medium'
 *          },
 *          height: {
 *              default: 'larger',
 * 				100: 'smaller',
 *  			200: 'small',
 *  			300: 'medium'
 * 			}
 *  	}}
 * 	>
 *
 *
 * ```
 *
 * @category Layout
 */
const WidgetWrapper = (props) => {
    var _a;
    let { className, children, cssBreakPoints } = props;
    const [sizeClasses, setSizeClasses] = React.useState('');
    // responsiveness
    const { observe } = useDimensions({
        onResize: ({ width, height }) => {
            let wClass = getSizeClass(cssBreakPoints === null || cssBreakPoints === void 0 ? void 0 : cssBreakPoints.width, width);
            let hClass = getSizeClass(cssBreakPoints === null || cssBreakPoints === void 0 ? void 0 : cssBreakPoints.height, height);
            setSizeClasses(`w-${wClass} h-${hClass}`);
        }
    });
    function getSizeClass(breaPoints, value) {
        let className = '';
        if (!breaPoints)
            return className;
        const { default: def } = breaPoints, rest = __rest(breaPoints, ["default"]);
        let sizes = Object.keys(rest).sort();
        for (const s of sizes) {
            if (value <= Number(s)) {
                className = rest[Number(s)];
                break;
            }
        }
        if (!hasValue(className))
            className = def;
        return className;
    }
    return (_jsxs("div", { className: classNames("uxpcore_widgetwrapper", sizeClasses, className), ref: observe, children: [children, _jsx(SampleDataLabel, { show: (_a = props.sampleData) === null || _a === void 0 ? void 0 : _a.showLabel })] }));
};
export default WidgetWrapper;
